
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.727 5.25l3.523 3.523a.382.382 0 010 .54l-8.531 8.53-3.625.403a.76.76 0 01-.84-.84l.402-3.625 8.532-8.531a.382.382 0 01.539 0zm6.328-.894l-1.907-1.907a1.528 1.528 0 00-2.156 0L17.61 3.832a.382.382 0 000 .54l3.524 3.523c.148.148.39.148.539 0l1.383-1.383a1.528 1.528 0 000-2.156zM16 15.523V19.5H3.5V7h8.977a.48.48 0 00.332-.137l1.562-1.562a.469.469 0 00-.332-.801H2.875C1.84 4.5 1 5.34 1 6.375v13.75C1 21.16 1.84 22 2.875 22h13.75c1.035 0 1.875-.84 1.875-1.875v-6.164a.47.47 0 00-.8-.332l-1.563 1.562a.48.48 0 00-.137.332z","fill":"#282E3E"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(1 2)","d":"M0 0h22.5v20H0z"}})])])])
          )
        }
      }
    